//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import BrigadeMapTaskCard from './BrigadeMapTaskCard.vue'
import BrigadeMapTasksList from './BrigadeMapTasksList.vue'
import { brigadeMapTasksListUtils } from './BrigadeMapTasksListUtils.js'
import { axiosPost } from '../../axios/axios.js'

export default {
  components: {
    BrigadeMapTaskCard,
    BrigadeMapTasksList
  },
  mixins: [brigadeMapTasksListUtils],
  props: {
    brigadeId: {
      type: Number,
      default: null
    },
    brigadeName: {
      type: String,
      default: ''
    },
    brigadeEndWorkTime: {
      type: Number,
      default: 0
    },
    completionRequests: {
      type: Array,
      default () {
        return []
      }
    },
    activeRequests: {
      type: Array,
      default () {
        return []
      }
    },
    queueRequests: {
      type: Array,
      default () {
        return []
      }
    },
    reinforcementRequests: {
      type: Array,
      default () {
        return []
      }
    },
    queueEditable: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      completionRequestsConfig: null,
      activeRequestsConfig: null,
      queueRequestsConfig: null,
      reinforcementRequestsConfig: null,

      queueRequestsEditingMode: false,
      queueRequestsLocal: [],
      queueRequestsLocalInfosToDelete: [],

      loading: false
    }
  },
  watch: {
    completionRequests: {
      handler: function (requests) {
        this.prepareRequestsListConfig('completionRequestsConfig', requests)
      },
      immediate: true
    },
    activeRequests: {
      handler: function (requests) {
        this.prepareRequestsListConfig('activeRequestsConfig', requests)
      },
      immediate: true
    },
    queueRequests: {
      handler: function (requests) {
        this.prepareRequestsListConfig('queueRequestsConfig', requests)
        this.queueRequestsLocal = JSON.parse(JSON.stringify(requests))
        this.queueRequestsLocalInfosToDelete = []
        this.queueRequestsEditingMode = false
      },
      immediate: true
    },
    reinforcementRequests: {
      handler: function (requests) {
        this.prepareRequestsListConfig('reinforcementRequestsConfig', requests)
      },
      immediate: true
    }
  },
  methods: {
    onMoveUp: function (index) {
      const element = this.queueRequestsLocal[index]
      this.queueRequestsLocal.splice(index, 1)
      this.queueRequestsLocal.splice(index - 1, 0, element)
    },
    onMoveDown: function (index) {
      const element = this.queueRequestsLocal[index]
      this.queueRequestsLocal.splice(index, 1)
      this.queueRequestsLocal.splice(index + 1, 0, element)
    },
    onDelete: function (index, cancelAppointmentAction) {
      const requestToDelete = this.queueRequestsLocal[index]
      this.queueRequestsLocalInfosToDelete.push({
        id: requestToDelete.id,
        cancelAppointmentAction
      })
      this.queueRequestsLocal = this.queueRequestsLocal.filter(request => request.id !== requestToDelete.id)
    },
    onReestablishQueue: function () {
      this.queueRequestsLocal = JSON.parse(JSON.stringify(this.queueRequests))
      this.queueRequestsLocalInfosToDelete = []
      this.$emit('editing-ended')
    },
    onCancel: function () {
      this.queueRequestsLocal = JSON.parse(JSON.stringify(this.queueRequests))
      this.queueRequestsLocalInfosToDelete = []
      this.queueRequestsEditingMode = !this.queueRequestsEditingMode
      this.$emit('editing-ended')
    },
    onEditQueue: function () {
      this.queueRequestsEditingMode = !this.queueRequestsEditingMode
      this.$emit('editing-started')
    },
    onSaveQueue: function () {
      const queueRequestsIds = this.queueRequests.map(request => request.id)
      const queueRequestsLocalIds = this.queueRequestsLocal.map(request => request.id)

      const bodyFormData = new FormData()
      bodyFormData.set('id', this.brigadeId)
      bodyFormData.set('ignoreEndWorkTime', true)
      bodyFormData.set('currentRequests', queueRequestsIds.join(','))
      if (queueRequestsLocalIds) {
        bodyFormData.set('requests', queueRequestsLocalIds.join(','))
      }

      if (this.queueRequestsLocalInfosToDelete.length) {
        const cancelAppointmentAction = {}
        this.queueRequestsLocalInfosToDelete.forEach(info => {
          cancelAppointmentAction[info.id] = info.cancelAppointmentAction
        })
        bodyFormData.set('allowExcludeRequests', false)
        bodyFormData.set('cancelAppointmentAction', JSON.stringify(cancelAppointmentAction))
      }

      this.loading = true
      axiosPost({
        url: '/service/delta/brigade/saveQueue',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешное изменение очереди заданий бригады',
            progress: true,
            timeout: 3000
          })

          this.$emit('queue-update')
        },
        onFailure: 'Ошибка изменения очереди заданий бригады',
        msgTarget: this
      }).finally(() => {
        this.loading = false
        this.$emit('editing-ended')
      })
    }
  }
}

